import {
  reqCgalList,
  reqCgalCentList,
  reqCgalSearchList,
  reqCgalenList,
  reqCgalenCentList,
  reqCgalenSearchList,
} from '@/api'
const state = {
  cgalList: [],
  cgalCentList: [],
  cgalSearchList: [],
  cgalenList: [],
  cgalenCentList: [],
  cgalenSearchList: [],
}
const mutations = {
  forCgalList(state, cgalList) {
    state.cgalList = cgalList
  },
  forCgalCentList(state, cgalCentList) {
    state.cgalCentList = cgalCentList
  },
  forCgalSearchList(state, cgalSearchList) {
    state.cgalSearchList = cgalSearchList
  },
  forCgalenList(state, cgalenList) {
    state.cgalenList = cgalenList
  },
  forCgalenCentList(state, cgalenCentList) {
    state.cgalenCentList = cgalenCentList
  },
  forCgalenSearchList(state, cgalenSearchList) {
    state.cgalenSearchList = cgalenSearchList
  },
}
const actions = {
  async CgalList({ commit }) {
    const result = await reqCgalList()
    if (result.code === 200) {
      commit('forCgalList', result.data)
    }
  },
  async CgalCentList({ commit }, cent) {
    console.log(cent)
    const encodedName = encodeURIComponent(cent)
    console.log('+++' + encodedName)
    const result = await reqCgalCentList(encodedName)
    console.log('+++' + encodedName)
    if (result.code === 200) {
      commit('forCgalCentList', result.data)
    }
  },
  async CgalSearchList({ commit }, title) {
    const result = await reqCgalSearchList(title)
    console.log(result)
    if (result.code === 200) {
      commit('forCgalSearchList', result.data)
    }
  },
  async CgalenList({ commit }) {
    const result = await reqCgalenList()
    if (result.code === 200) {
      commit('forCgalenList', result.data)
    }
  },
  async CgalenCentList({ commit }, cent) {
    console.log(cent)
    const result = await reqCgalenCentList(cent)
    console.log(result)
    if (result.code === 200) {
      commit('forCgalenCentList', result.data)
    }
  },
  async CgalenSearchList({ commit }, title) {
    const result = await reqCgalenSearchList(title)
    console.log(result)
    if (result.code === 200) {
      commit('forCgalenSearchList', result.data)
    }
  },
}
const getters = {}
export default {
  state,
  mutations,
  actions,
  getters,
}
